import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptPortfolioData } from "@repo/shared-utils/crypto";
import { isOpenInApp, stringToBoolean } from "@repo/shared-utils/pwa-utils";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import {
  componentNameConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";

export const handlePortfolioRedirection = async (
  url: string,
  openInNewTab: string,
  reportTitle: string,
  screen: string,
  type: string,
  headerName?: string,
) => {
  const data = await getSessionData();
  const target = stringToBoolean(openInNewTab) ? "_blank" : "_self";
  const redirectUrl = new URL(url);
  const reportData = {
    mobileNo: data?.mobileNo || "",
    screen: screen,
    type: type,
  };
  const encryptedData = await encryptPortfolioData(reportData);
  redirectUrl.searchParams.append("req", encryptedData ?? "");
  if (isOpenInApp()) {
    window.prompt(
      `openInAppWebViewActivity://{"url":"${redirectUrl}","title":"${headerName ?? "Bajaj Security"}"}`,
    );
  } else {
    window.open(redirectUrl.toString(), target);
  }
  dataLayer(
    "",
    {
      section_title: "Portfolio",
      event: dlEventConstants.CLICK,
      element: dlEventConstants.REPORTS_CLICK,
      cta_text: reportTitle,
      event_type: dlEventConstants.REPORTS_CLICK,
      destination_url: url,
    },
    {
      EP_PAGE_NAME: componentNameConstants.PORTFOLIO_NAME,
      EP_CTA: reportTitle,
    },
  );
};
